import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'copyright',
})
@Injectable()
export class Copyright implements PipeTransform {
  /*
    Takes a value and makes it lowercase.
   */
  transform(value: string): string {
    value = value + ''; // make sure it's a string
    if (value.search('©') >= 0) {
      return value.replace('©', '');
    } else {
      return value;
    }
  }
}
